import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { isOneOfVeloViewers } from '../../../../utils';
import { isBranch } from '../../../../utils/locationUtils';
import { BranchNotification } from '../../BranchNotification';
import { getHomePageUrl } from '../../CurrentLocationBreadcrumbs/utils';
import MainContent from '../../Layout/MainContent/MainContent';
import NavigationMenu from '../../NavigationMenu/NavigationMenu';
import { PreviewNotification } from '../../PreviewNotification';
import { RelatedSitesAndSearchContainer } from '../../RelatedSitesAndSearchContainer';
import { StoreContext } from '../../../appContext/StoreProvider/index';
import TopBar from '../../TopBar/TopBar';
import { OpenNavigationButton } from '../OpenNavigationButton';
import style from './MainApp.scss';
import { NewSearchContainer } from '../../NewSearchContainer';

const _MainApp = React.memo(
  ({ match, staticContext, location, isPreview }) => {
    const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);
    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
    const { store } = useContext(StoreContext);
    const homePageUrl = getHomePageUrl(store);

    useEffect(() => {
      window.addEventListener('keyup', openSearchOnKeyUp);

      const cleanUp = () => {
        window.removeEventListener('keyup', openSearchOnKeyUp);
      };

      return cleanUp;
    }, []);

    const openSearchOnKeyUp = (e) => {
      if (e.keyCode === 191) {
        setIsSearchModalOpen(true);
      }
    };

    const toggleMenu = () => {
      setIsHamburgerMenuOpen(!isHamburgerMenuOpen);
    };

    const goToHomePage = () => {
      store.publishToFocusLocation(homePageUrl);
    };

    const closeMenu = () => {
      isHamburgerMenuOpen && setIsHamburgerMenuOpen(false);
    };

    return (
      <main className={style.root}>
        <NewSearchContainer
          isOpen={isSearchModalOpen}
          closeModal={() => setIsSearchModalOpen(false)}
          viewer={store.viewer}
        />
        {isPreview && <PreviewNotification />}
        {isBranch(location) && !isPreview && <BranchNotification />}
        {(isOneOfVeloViewers(store.viewer.category) ||
          store.viewer.isInternalViewer()) && (
          <TopBar
            toggleMenu={toggleMenu}
            onLogoClicked={goToHomePage}
            isPreview={isPreview}
          />
        )}
        <RelatedSitesAndSearchContainer
          openSearchModal={() => setIsSearchModalOpen(true)}
          isPreview={isPreview}
          staticContext={staticContext}
        />
        <OpenNavigationButton onClick={toggleMenu} />
        <NavigationMenu
          isHamburgerMenuOpen={isHamburgerMenuOpen}
          closeMenu={closeMenu}
          isPreview={isPreview}
        />
        <MainContent
          match={match}
          staticContext={staticContext}
          isPreview={isPreview}
        />
      </main>
    );
  },
  ({ location: prevLocation }, { location: nextLocation }) => {
    if (prevLocation.search !== nextLocation.search) {
      return false;
    }
    return true;
  },
);

export const MainApp = withRouter(_MainApp);
